import { Mail, Phone } from "lucide-react";

const typeLabels = {
  support: "Financial Support",
  partnership: "Partnership",
  volunteer: "Volunteer",
  prayer: "Prayer",
};

const statusColors = {
  new: "bg-brand-terracotta/15 text-brand-terracotta",
  reviewed: "bg-brand-sand/25 text-[#8a6a3a]",
  contacted: "bg-brand-green/15 text-brand-green",
};

export default function PledgeRow({ p, changeStatus }) {
  return (
    <div className="bg-brand-bg border border-brand-line rounded-2xl p-6" data-testid={`admin-pledge-${p.id}`}>
      <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-4">
        <div className="min-w-0">
          <div className="flex items-center gap-3 flex-wrap mb-2">
            <h3 className="font-serif text-xl text-brand-ink">{p.name}</h3>
            <span className={`text-xs px-3 py-1 rounded-full ${statusColors[p.status] || statusColors.new}`}>
              {p.status}
            </span>
            <span className="text-xs px-3 py-1 rounded-full bg-brand-surface text-brand-muted">
              {typeLabels[p.interest_type] || p.interest_type}
            </span>
            {p.pledge_amount && (
              <span className="text-xs px-3 py-1 rounded-full bg-brand-green/10 text-brand-green font-medium">
                Pledge: {p.pledge_amount}
              </span>
            )}
          </div>
          <div className="flex flex-wrap gap-4 text-sm text-brand-muted mb-3">
            <a href={`mailto:${p.email}`} className="inline-flex items-center gap-1.5 hover:text-brand-green">
              <Mail className="w-3.5 h-3.5" /> {p.email}
            </a>
            {p.phone && (
              <span className="inline-flex items-center gap-1.5"><Phone className="w-3.5 h-3.5" /> {p.phone}</span>
            )}
            <span>{new Date(p.created_at).toLocaleString()}</span>
          </div>
          <p className="text-brand-ink leading-relaxed">{p.message}</p>
        </div>

        <select
          data-testid={`admin-status-select-${p.id}`}
          value={p.status}
          onChange={(e) => changeStatus(p.id, e.target.value)}
          className="bg-brand-surface border border-brand-line rounded-lg px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-brand-green shrink-0"
        >
          <option value="new">New</option>
          <option value="reviewed">Reviewed</option>
          <option value="contacted">Contacted</option>
        </select>
      </div>
    </div>
  );
}
